import React from 'react';
import PropTypes from 'prop-types';
import { StyledPillText } from './styles';

export const PillText = ({
  text,
  variant = 'light',
  size = 'large',
  icon = null,
  iconAlignment = 'left',
  wiggle = false,
  wiggleDelay = 10,
}) => {
  const iconSrc =
    typeof icon?.src === 'string' ? icon.src : icon?.src?.src || null;

  const iconNode = iconSrc ? (
    <img
      src={iconSrc}
      alt={icon.alt || ''}
      width={icon.width || 14}
      height={icon.height || 14}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  ) : null;

  return (
    <StyledPillText
      variant={variant}
      size={size}
      $wiggle={wiggle}
      $wiggleDelay={wiggleDelay}
    >
      {iconAlignment === 'left' && iconNode}
      <span>{text}</span>
      {iconAlignment === 'right' && iconNode}
    </StyledPillText>
  );
};

PillText.displayName = 'PillText';
PillText.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf([
    'light',
    'dark',
    'lilac',
    'yellow',
    'warning',
    'success',
    'disabled',
    'glass',
    'glassLight',
  ]),
  size: PropTypes.oneOf(['small', 'large']),
  icon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  iconAlignment: PropTypes.oneOf(['left', 'right']),
  wiggle: PropTypes.bool,
  wiggleDelay: PropTypes.number,
};
